import { Button, Form, Input, notification } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import logorace from "../../../assets/img/Logo-RACE-Raja-Cepat.png";
import axios from "axios";
import { BaseUrlRace } from "../../../Api/BaseUrl";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "./style.css";
import ReCAPTCHA from "react-google-recaptcha";

function LoginRaceCustomer() {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [loading, setLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState("");
  const history = useHistory();

  async function loginCustomer() {
    if (!captchaValue) {
      notification.error({
        message: "Please complete the reCAPTCHA",
      });
      return;
    }

    const body = {
      username: username,
      password: password,
      captchaValue: captchaValue,
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${BaseUrlRace}auth/login-customer`,
        body
      );
      const data = response.data;

      notification.success({
        message: data.status?.message,
      });

      const loginData = data.data;
      localStorage.setItem("token", loginData.token);
      localStorage.setItem("jobdesk", loginData.divisi);
      localStorage.setItem("cabang", loginData.cabang);
      localStorage.setItem("loginBu", loginData.loginBu);
      localStorage.setItem("username", loginData.username);
      setLoading(false);
      history.push("/race/cabang/dashboard");
    } catch (error) {
      const errorResponse = error.response.data;
      if (
        errorResponse &&
        errorResponse.errors &&
        Array.isArray(errorResponse.errors)
      ) {
        errorResponse.errors.forEach((errorItem) => {
          notification.error({
            message: errorItem.message || "Terjadi kesalahan pada server",
          });
        });
      } else {
        notification.error({
          message: "Terjadi kesalahan pada server",
        });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="d-flex justify-content-center warp-awal"
      style={{
        alignItems: "center",
        height: "100vh",
        background: "linear-gradient(to bottom right, #FF640BFF, #FF7A2F)",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        style={{
          backgroundColor: "#FFFFFFFF",
          boxShadow: "10px 4px 20px 2px rgba(1, 1, 0.1, 0.2)",
          maxHeight: "40rem",
          width: "500px",
          borderRadius: "10px",
          padding: 20,
        }}
      >
        <div className="login-from">
          <Row>
            <Col className="mx-4 mt-2">
              <div className="d-flex justify-content-center ">
                <img
                  src={logorace}
                  alt="logo"
                  style={{ maxHeight: "10rem", width: "12rem" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "5px",
                }}
              >
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#000000FF",
                    textAlign: "center",
                  }}
                >
                  Welcome Login Dasboard
                  <p>Cabang Erlangga</p>
                </div>
              </div>
              <Form.Item className="">
                <div
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    marginBottom: 5,
                  }}
                >
                  Username
                </div>
                <Input
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderRadius: "10px",
                  }}
                  placeholder="Masukkan Username Cabang"
                  onChange={(e) => setUsername(e.target.value)}
                />
              </Form.Item>
              <Form.Item>
                <div
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    marginBottom: 5,
                  }}
                >
                  Password
                </div>
                <Input
                  placeholder="Masukkan Password Cabang"
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderRadius: "10px",
                  }}
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Item>
            </Col>

            <div
              className="justify-content-center items-center d-flex"
              style={{ backgroundColor: "" }}
            >
              <Button
                onClick={loginCustomer}
                style={{
                  width: "98%",
                  backgroundColor: "#1f3d7d",
                  color: "white",
                  height: "45px",
                  borderRadius: "10px",
                }}
              >
                {loading ? "Loading..." : "Login"}
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                paddingBottom: "80px", // beri ruang di bawah agar tombol tidak menimpa
              }}
            >
              <div
                style={{
                  maxWidth: "fit-content",
                  zIndex: "9999",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ReCAPTCHA
                  sitekey="6LfxogsqAAAAANeKKQon9zQceO6h87yMmIuI80Vz"
                  onChange={(value) => {
                    setCaptchaValue(value);
                  }}
                />
              </div>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default LoginRaceCustomer;
